// export const PHONE_PATTERN = /^\d{4}$|^\d{10}$/
export const PHONE_PATTERN = /^0\d{9}$/
